export const PAGE_PATHS = {
  landing: "/",
  about: "/about",
  terms: "/terms",
  privacy: "/privacy",
  contact: "/contact-us",
  dashboard: "/dashboard",
  pricing: "/pricing",
  creditsPlans: "/credits-plans",
  login: "/sign-in",
  signUp: "/sign-up",
  emailVerificationRequired: "/email-verification-required",
  payment: "/payment",
  readingHistory: "/reading-history",
  settings: "/settings",
  tarot: "/tarot",
  wedding: "/wedding",
  coupleMatch: "/couple-match",
  western: "/western-astrology",
  chinese: "/chinese-zodiac",
};

export const PREDICTION_FEATURE_TO_PAGE = {
  western: "western",
  chinese: "chinese",
  tarot: "tarot",
  wedding: "wedding",
  couple_match: "coupleMatch",
};

export const ACCENTS = {
  "purple-gold": { primary: "#a378ff", secondary: "#f0c060", tertiary: "#5e7fff" },
  "teal-blue": { primary: "#5ef0d8", secondary: "#7fb4ff", tertiary: "#a378ff" },
  "rose-gold": { primary: "#f0a0c0", secondary: "#f0c060", tertiary: "#c878ff" },
};

export const GLOW = { low: "0.3", medium: "0.55", high: "0.85" };

export const C = {
  bg0: "#050818",
  bg1: "#080d20",
  bg2: "#0c1230",
  bg3: "#111840",
  glass: "rgba(255,255,255,0.04)",
  glassBorder: "rgba(255,255,255,0.10)",
  textPrimary: "#edeaf8",
  textSecondary: "#9590b8",
  textMuted: "#5c5880",
};

export const TERMS_CONTACT_EMAIL = "minhphamuit91@gmail.com";
export const PRIVACY_REQUEST_EMAIL = "minhphamuit91@gmail.com";
export const FOOTER_CONTACT_EMAIL = "minhphamuit91@gmail.com";

// i18n/constants
export const LOCALE_STORAGE_KEY = "ecliptica.locale";
export const SUPPORTED_LOCALES = ["en", "vi"];
export const DEFAULT_DISPLAY_TIMEZONE = "Asia/Bangkok";
export const DISPLAY_TIMEZONE_STORAGE_KEY = "ecliptica.timezone";

export const VI_PRICE_MAP = {
  "$2.99": "59,000₫",
  "$5.99": "119,000₫",
  "$9.99": "199,000₫",
  "$13.99": "279,000₫",
};

// Navigation/constants
export const NAV_ITEMS = [
  { id: "dashboard", labelKey: "sidebar_dashboard", icon: "◈" },
  { id: "chinese", labelKey: "sidebar_chinese_zodiac", icon: "☯" },
  { id: "western", labelKey: "sidebar_western_astrology", icon: "☉" },
  { id: "tarot", labelKey: "sidebar_tarot_reading", icon: "⊕" },
  { id: "wedding", labelKey: "sidebar_wedding_date", icon: "♡" },
  { id: "coupleMatch", labelKey: "sidebar_couple_match", icon: "囍" },
  { id: "creditsPlans", labelKey: "credits_and_plans", icon: "¤" },
  { id: "settings", labelKey: "account_settings", icon: "⚙" },
  { id: "contact", labelKey: "contact_us", icon: "\u2709" },
];

export const MOBILE_PRIMARY_NAV_IDS = ["dashboard", "chinese", "western", "tarot", "wedding", "coupleMatch"];

export const MOBILE_PRIMARY_NAV = NAV_ITEMS.filter((item) => MOBILE_PRIMARY_NAV_IDS.includes(item.id));

const navItemById = Object.fromEntries(NAV_ITEMS.map((item) => [item.id, item]));

export const DASHBOARD_QUICK_ACTIONS = [
  { id: "chinese", labelKey: "dashboard_cta_chinese_zodiac", ctaId: "dashboard_cta_chinese" },
  { id: "western", labelKey: "dashboard_cta_birth_chart", ctaId: "dashboard_cta_western" },
  { id: "tarot", labelKey: "dashboard_cta_draw_tarot", ctaId: "dashboard_cta_tarot" },
  { id: "wedding", labelKey: "dashboard_cta_wedding_compatibility", ctaId: "dashboard_cta_wedding" },
  { id: "coupleMatch", labelKey: "dashboard_cta_couple_match", ctaId: "dashboard_cta_couple_match" },
].map((action) => ({
  ...action,
  icon: navItemById[action.id]?.icon || "◈",
}));

// Western zodiac/constants
export const WZ_SIGNS = [
  { s: "♈", n: "Aries", el: "Fire", mod: "Cardinal", col: "#ff6b6b" },
  { s: "♉", n: "Taurus", el: "Earth", mod: "Fixed", col: "#a8e063" },
  { s: "♊", n: "Gemini", el: "Air", mod: "Mutable", col: "#f7d794" },
  { s: "♋", n: "Cancer", el: "Water", mod: "Cardinal", col: "#74b9ff" },
  { s: "♌", n: "Leo", el: "Fire", mod: "Fixed", col: "#fdcb6e" },
  { s: "♍", n: "Virgo", el: "Earth", mod: "Mutable", col: "#55efc4" },
  { s: "♎", n: "Libra", el: "Air", mod: "Cardinal", col: "#fd79a8" },
  { s: "♏", n: "Scorpio", el: "Water", mod: "Fixed", col: "#6c5ce7" },
  { s: "♐", n: "Sagittarius", el: "Fire", mod: "Mutable", col: "#e17055" },
  { s: "♑", n: "Capricorn", el: "Earth", mod: "Cardinal", col: "#81ecec" },
  { s: "♒", n: "Aquarius", el: "Air", mod: "Fixed", col: "#a29bfe" },
  { s: "♓", n: "Pisces", el: "Water", mod: "Mutable", col: "#74b9ff" },
];

export const WZ_GLYPHS = WZ_SIGNS.map(({ s }) => s);

export const WZ_PLANETS = [
  { sym: "☉", name: "Sun", col: "#fdcb6e" },
  { sym: "☽", name: "Moon", col: "#dfe6e9" },
  { sym: "☿", name: "Mercury", col: "#b2bec3" },
  { sym: "♀", name: "Venus", col: "#fd79a8" },
  { sym: "♂", name: "Mars", col: "#ff7675" },
  { sym: "♃", name: "Jupiter", col: "#e17055" },
  { sym: "♄", name: "Saturn", col: "#636e72" },
  { sym: "♅", name: "Uranus", col: "#74b9ff" },
  { sym: "♆", name: "Neptune", col: "#6c5ce7" },
];

export const WZ_HOUSES = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];

export const WZ_HOUSE_THEMES = [
  "Self & Identity",
  "Wealth & Values",
  "Communication",
  "Home & Roots",
  "Creativity & Joy",
  "Health & Service",
  "Partnerships",
  "Transformation",
  "Philosophy",
  "Career",
  "Community",
  "Spirituality",
];

export const WZ_ASPECTS = [
  { name: "Conjunction", sym: "☌", deg: 0, col: "#fdcb6e" },
  { name: "Sextile", sym: "⚹", deg: 60, col: "#55efc4" },
  { name: "Square", sym: "□", deg: 90, col: "#ff7675" },
  { name: "Trine", sym: "△", deg: 120, col: "#74b9ff" },
  { name: "Opposition", sym: "☍", deg: 180, col: "#a29bfe" },
];
